import { Component, ViewChild } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { messages } from '../../funciones/mensajes';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from '../../../services/excel/excel.service';
import { ProyectosestrategicosService } from '../../../services/seguimiento/proyectosestrategicos/proyectosestrategicos.service';
import { MatTableDataSource } from '@angular/material/table';
import { Meses, obtenerTamMax } from '../../../models/Formulacion/indicadores-metas/datos';
import { ActivatedRoute, Router } from '@angular/router';
import { MatMenuTrigger } from '@angular/material/menu';
import { FiltersM } from '../../../components/models';
import { firstValueFrom } from 'rxjs';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { PerspectivaService } from '../../../services/gestion/perspectivas/perspectiva.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { StrategiaService } from '../../../services/gestion/strategias/strategia.service';
import { ProyectosService } from '../../../services/gestion/proyectos/proyectos.service';
import { PERMISOS } from '../../../shared/catalogos';
import { AdicionalService } from '../../../services/gestion/adicional/adicional.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { ActividadService } from '../../../services/gestion/actividad/actividad.service';

@Component({
  selector: 'app-proyectos-estrategicos',
  templateUrl: './proyectos-estrategicos.component.html',
  styleUrl: './proyectos-estrategicos.component.css'
})
export class ProyectosEstrategicosComponent {
  public readonly permisos = PERMISOS;

  public Filters = FiltersM;
  private idPlanificacion: number = 0;
  skeleton = ['','','','','','','','','']

  //Variables de datos
  public perspectives: any = [];
  public aniosDisponibles: any = [];
  public aniosDisponiblesTot: any = [];
  private semaforo: any = [];
  public objectives: any = [];
  public programas: any = [];
  public responsables: any = [];
  public responsablesInstitucion: any = [];
  public responsables2: any = [];
  public responsablesAct: any = [];
  public responsablesAct2: any = [];
  public proyectos: any = [];
  private proyectosFin: any = [];
  public actividades: any = [];
  public actividadesFull: any = [];
  public proyectosMostrar: any = [];
  private diasLab: any;
  private fechaAct = new Date();
  private edicion: boolean;
  public Periodo = '';
  public mesMos = '';
  public aniMos = '';
  public perspectiva = '';
  public objetivo = '';
  public programa = '';
  public expandirProg = false;

  //filtros seleccionables
  public perSelect = '';
  public objSelect = '';
  public proSelect = '';
  public mostrarTable = false;
  public mostrarPeriodo =  true;
  public verStats = false;
  // Filtros
  public todasPer = true;
  public todasPerAct = true;

  // **** Variables para el formateo de numeros
  public separador:string =  ","; // separador para los miles
  public sepDecimal:string = '.'; // separador para los decimales

/** Lectura de archivos */
  selectedFiles: FileList;
  //Es el array que contiene los items para mostrar el progreso de subida de cada archivo
  progressInfo = [];
  message = '';
  imageName = "";

  public  ordenamiento = 'id';
  public estats = [
    {name: 'Reprogramada', check: true},
    {name: 'Cumplida', check: true},
    {name: 'Incumplida', check: true},
    {name: 'En proceso', check: true},
    {name: 'No iniciada', check: true},
  ];

  public allStats = true;
  /** click izquierdo */
  @ViewChild(MatMenuTrigger, {static: true}) matMenuTrigger: MatMenuTrigger;

  menuTopLeftPosition =  {x: '0', y: '0'};
  private adDelete : any;
  private adActivi : any;

  constructor(
    public dataService: DataService,
    private cookieService: CookieService,
    private router: Router,
    private excelService: ExcelService,
    private translate: TranslateService,

    private planificacionService: PlanificacionService,
    private responsableService: ResponsableService,
    private objetivoService: ObjetivoService,
    private strategiaService: StrategiaService,
    private proyectosService: ProyectosService,
    private actividadService: ActividadService,
    private adicionalService: AdicionalService,
  ) {
    this.idPlanificacion = Number(cookieService.get('idInstitucion'));
    this.obtenerDatos();
    moment.updateLocale('en',{
      months: [
        "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto",
        "Septiembre","Octubre","Noviembre","Diciembre"
      ],
      monthsShort: [
        "Ene","Feb","Mar","Abr","May","Jun","Jul","Ago",
        "Sep","Oct","Nov","Dic"
      ]
    });
  }
  ngOnInit(): void {}
  private async obtenerDatos(){
    try{
      const planeacionResponse = await this.planificacionService.getPlanificacionByIdGQL(this.idPlanificacion);
      this.obtenerFiltros(planeacionResponse);
      this.perspectives = this.ordenamientoId(this.perspectives);

      const objectives = [];
      for(const per of this.perspectives){
        const obj = await this.objetivoService.getObjectivesByPerspectiveGQL(per.id);
        objectives.push(...obj)
      }
      this.searchProyectsAndPrograms(objectives)
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  private seleccionarPeriodo(){
    this.aniosDisponibles.forEach(a => {
      a.series.forEach(m => m.check = false);
    });
    const ultimoAnio = this.aniosDisponibles[this.aniosDisponibles.length - 1];
    const ultimoPeriodo = ultimoAnio.series[ultimoAnio.series.length - 1];

    const periodoActual = moment().format('MMM-YY').toLowerCase();

    if (ultimoPeriodo.periodo === periodoActual) {
      const series = ultimoAnio.series;
      const indice = series.length - 1;

      if (indice > 0) {
        series[indice - 1].check = true;
        this.Periodo = series[indice - 1].periodo;
        this.mesMos = series[indice - 1].mes;
        this.aniMos = series[indice - 1].anio;
      }
    } else {
      ultimoPeriodo.check = true;
      this.Periodo = ultimoPeriodo.periodo;
      this.mesMos = ultimoPeriodo.mes;
      this.aniMos = ultimoPeriodo.anio;
    }
  }
  private async obtenerFiltros(plan: any){
    if(Number(plan.id) === this.idPlanificacion){
      this.edicion = plan.isActive;
      this.diasLab = plan.business_days;
      this.aniosDisponibles = Meses.obtenerPeriodos(moment(plan.initial_date).toDate(), moment(plan.end_date).toDate());
      this.aniosDisponiblesTot = Meses.obtenerPeriodos(moment(plan.initial_date).toDate(), moment(plan.end_date).toDate());
      this.seleccionarPeriodo();
      for(const per of plan.perspectives){
        this.perspectives.push({
          name: per.name,
          check: false,
          id: per.id,
        })
      }
      try{
        const response = await firstValueFrom(this.responsableService.getResponsable()); 
        this.responsablesInstitucion = [];
        for(const are of response){
          if(Number(are.institution.id) === Number(plan.institution.id)){
            for(const res of are.responsibles){
              this.responsablesInstitucion.push({
                nombre: res.position,
                id: res.id,
                check: true,
                institucion: are.institution.name,
              });
            }
          }
        }
      }catch(err){
        messages.errorMessageGraph(err);
      }
      this.perspectives = this.ordenamientoId(this.perspectives);
      const sema = this.ordenamientoSem(plan.signals);
      if( Number(sema[sema.length-1].value_01) > 100){
        const valFinal = Number(sema[sema.length-1].value_01); 
        for(const sem of sema){
          this.semaforo.push({
            valIn: Math.round((Number(sem.value_00)*100)/valFinal) === 0? Math.round((Number(sem.value_00)*100)/valFinal):Math.round((Number(sem.value_00)*100)/valFinal)+0.1,
            valfin: Math.round((Number(sem.value_01)*100)/valFinal),
            color: sem.color[0],
          });
        }      
      }else{
        for(const sem of sema){
          this.semaforo.push({
            valIn: Number(sem.value_00),
            valfin: Number(sem.value_01),
            color: sem.color[0],
          });
        }
      }
    }
  }
  private obtenerResponsablesDin(){
    var aux = [], aux2 = []; 
    for(const pro of this.proyectosMostrar){
      const res = aux.filter(res => res.id === pro.proyecto.responsible.id);
      if(res.length === 0){
        aux.push({
          id: pro.proyecto.responsible.id,
          name: pro.proyecto.responsible.position,
          check: true,
        });
      }
      for(const act of pro.actividades){
        const resAct = aux2.filter(res => res.id === act.responsible.id);
        if(resAct.length === 0){
          if(this.dataService.filtradoIndicadores){
            if(act.responsible.email === this.dataService.user){
              aux2.push({
                id: act.responsible.id,
                name: act.responsible.position,
                check: true,
              });
            }
          }else{
            aux2.push({
              id: act.responsible.id,
              name: act.responsible.position,
              check: true,
            });
          }
        }
      }
    }
    this.responsables = this.ordenamientoAlf(aux);
    this.responsables2 = new MatTableDataSource(this.responsables);
    this.responsablesAct = this.ordenamientoAlf(aux2);
    this.responsablesAct2 = new MatTableDataSource(this.responsablesAct);
  }
  private searchProyectsAndPrograms(objectives: any){
    this.objectives = [];
    this.objectives = this.ordenamientoId(objectives);

    var strat = [], proyects = [];
    this.objectives.forEach( obj => {
      strat = strat.concat(obj.strategies.map(s => {return s.id}))
      proyects = proyects.concat(obj.projects.map(s => {return s.id}))
    });

    this.obtProgramas(strat);
    this.obtProyectos(proyects);
  }

  private async obtProgramas(strat: any){
    strat = [...new Set(strat)];
    const array = [];
    for (let i = 0; i < strat.length; i += 10) {
      const batch = strat.slice(i, i + 10);
      const results = await this.strategiaService.getStrategyGQL(batch);
      array.push(...results);
    }

    var aux = [];
    for(const prog of array){
      for(const obj of this.objectives){
        if(prog.objectives.length !== 0 && prog.objectives[0].id === obj.id){
          aux.push({
            id: prog.id,
            name: prog.name,
            description: prog.description,
            projects: this.ordenamientoId(prog.projects),
            objectives: this.ordenamientoId(prog.objectives),
            avance: 0,
            atraso: 0,
          });
        }
      }      
    }
    this.programas = [];
    this.programas = this.ordenamientoObjId(this.ordenamientoId(aux));
  }
  private async obtProyectos(proyects: any){
    proyects = [...new Set(proyects)];
    const array = [];
    for (let i = 0; i < proyects.length; i += 10) {
      const batch = proyects.slice(i, i + 10);
      const results = await this.proyectosService.getProyectsGQL(batch);
      array.push(...results);
    }
    this.proyectos = [];
    this.actividadesFull = [];
    var aux = [];
    for(const pro of array){
      const existe = this.objectives.filter( o => Number(o.id) === Number(pro.objectives[0].id) );
      if(existe.length !== 0){
        for(const act of pro.activities){
          var hist = [];
          var historicosCom = Meses.obtenerPlaneado(this.obtFech(act.initial_date), this.obtFech(act.end_date), this.diasLab); //ok
          let hisAg = 0;
          for(const his of historicosCom){
            const ex = act.historic.find(h => h.period === his.periodo);
            if(ex){
              hist.push({
                periodo: ex.period,
                planeado: Number(ex.planned),
                ejecutado: ex.executed,
                id: ex.id,
              });
              hisAg++;
            }else{
              hist.push({
                periodo: his.periodo,
                planeado: Number(his.planeado),
                ejecutado: his.ejecutado,
                id: his.id,
              });
            }
          }
          if(hisAg !== act.historic.length){
            for(const h of act.historic){
              const ex = hist.filter(hi => hi.periodo === h.period);
              if(ex.length === 0){
                hist.push({
                  periodo: h.period,
                  planeado: Number(h.planned),
                  ejecutado: h.executed,
                  id: h.id,
                });
              }
            }
          }
          const ad = this.ordenamientoAd(act.additions)
          hist = this.ordenamientoHis(hist);
          aux.push({
            additions: ad,
            end_date: moment(act.end_date.split('T')[0]),
            id: act.id,
            initial_date: moment(act.initial_date.split('T')[0]),
            name: act.name,
            project: {id: pro.id, name: pro.name},
            responsible: act.responsible,
            historico: hist,
            completed: act.completed
          });
        }
        this.proyectos.push({
          activities: aux,
          code: pro.code,
          description: pro.description,
          historicWeighing: pro.historicWeighing, 
          id: pro.id,
          name: pro.name,
          objectives: pro.objectives,
          projectWeighing: pro.projectWeighing,
          responsible: pro.responsible,
          strategies: pro.strategies,
          weighing: pro.weighing
        });
        this.actividadesFull = this.actividadesFull.concat(JSON.parse(JSON.stringify(aux)));          
        aux = [];
      }
    }
    this.obtenerProyectosPeriodo();
  }
  private obtenerProyectosPeriodo(){
    var array = this.ordenamientoId(JSON.parse(JSON.stringify(this.proyectos)));
    var proyectosPeriodo = [], actividadesPeriodo = [];
    var auxAct = []
    for(const pro of array){
      for(const act of pro.activities){
        const resAct = this.responsablesInstitucion.filter(res => Number(res.id) === Number(act.responsible.id));
        const historico = this.obtenerHistorico(act);
        if(historico !== undefined && resAct.length !== 0){
          act.historico = [historico];
          var hist = [];
          for(const his of act.historico){
            hist.push({
              periodo: his.periodo,
              planeado: his.planeado,
              ejecutado: his.ejecutado,
              id: his.id,
            });
          }
          let edit = true;
          if(historico.planeado === '-'){
            edit = false;
          }
          auxAct.push({
            additions: act.additions,
            end_date: moment(act.end_date.split('T')[0]),
            id: act.id,
            initial_date: moment(act.initial_date.split('T')[0]),
            name: act.name,
            project: act.project,
            responsible: act.responsible,
            historico: hist,
            editable: edit,
          });    
          actividadesPeriodo.push({
            additions: act.additions,
            end_date: moment(act.end_date.split('T')[0]),
            id: act.id,
            initial_date: moment(act.initial_date.split('T')[0]),
            name: act.name,
            project: pro,
            responsible: act.responsible,
            historico: hist,
            editable: edit,
          });
        }
      }
      
      if(auxAct.length !== 0){
        proyectosPeriodo.push({
          proyecto: pro,
          actividades: auxAct,
          check: false,
          fecha_ini:undefined,
          fecha_fin: undefined,
          planeado: 0,
          ejecutado: 0,
        });
      }
      auxAct = [];
    }
    proyectosPeriodo = this.obtfechasProy(proyectosPeriodo);
    this.proyectosFin = proyectosPeriodo;
    this.actividades = actividadesPeriodo;
    
    
    if(this.dataService.filtradoIndicadores){
      this.obtenerProy('all');
      this.obtenerResponsablesDin();
    }else{
      this.obtenerProy('cam');
      this.obtenerResponsablesDin();
    }
    this.mostrarTable = true;
  }
  public obtfechasProy(array: any){
    for(const pro of array){
      pro.fecha_fin = undefined;
      pro.fecha_ini = undefined;
      for(const act of pro.proyecto.activities){
        var fecha_inicio = moment(act.initial_date.split('T')[0]), fecha_fin = moment(act.end_date.split('T')[0]);
        if(pro.fecha_ini === undefined){
          pro.fecha_ini = fecha_inicio;
        }else{          
          if(pro.fecha_ini.isAfter(fecha_inicio)){
            pro.fecha_ini = fecha_inicio;
          }
        }
        if(pro.fecha_fin === undefined){
          pro.fecha_fin = fecha_fin;
        }else{
          if(pro.fecha_fin.isBefore(fecha_fin)){
            pro.fecha_fin = fecha_fin;
          }
        }
      }
    }

    return array;
  }
  /* Revisión de proyectos con cumplimiento o no */
  public obtenerHistorico(act){
    var per = this.perSelected();

    const fecPer = moment(Meses.escrituraPer(per), 'MM/DD/YY');
    const actFI = moment(act.initial_date.split('T')[0]);
    const actFF = moment(act.end_date.split('T')[0]);
    let historicoEva = undefined;
    if(actFI.isBefore(fecPer) && actFF.isBefore(fecPer) && this.actividadIncompleta(act)){
      historicoEva = act.historico.filter(his => his.periodo === per)[0];
      if(historicoEva === undefined){
        historicoEva = {
          periodo: per,
          planeado: 100,
          ejecutado: null,
          id: 0,
        }
      }
    }else if(actFI.isBefore(fecPer) && actFF.isBefore(fecPer) && !this.actividadIncompleta(act)){
      historicoEva = act.historico.filter(his => his.periodo === per)[0];
      if(historicoEva === undefined){
        historicoEva = {
          periodo: per,
          planeado: '-',
          ejecutado: '-',
          id: '',
        }
      }
    }else if(actFI.isBefore(fecPer) || actFI.isSame(fecPer, 'month')){
      historicoEva = act.historico.filter(his => his.periodo === per)[0];
    }

    return historicoEva;
  }
  private actividadIncompleta(act: any){
    var mes = Meses.getMesesS(this.Periodo.split('-')[0])<10?'0'+Meses.getMesesS(this.Periodo.split('-')[0]):''+Meses.getMesesS(this.Periodo.split('-')[0]);
    const momentAct = moment('01-'+mes+'-20'+this.Periodo.split('-')[1], 'DD-MM-YYYY');

    var fechaFinAct;
    if((act.end_date+'').includes('Z')){
      fechaFinAct = moment(act.end_date.split('T')[0]);
    }else{
      fechaFinAct = moment(act.end_date);
    }
    const momnetFinAct = moment(fechaFinAct);
    
    if(momentAct.isAfter(momnetFinAct) && act.completed !== true){
      return true;
    }
    return false;
  }
  /* Pintar bordes */
  public pintarBord(eje: any, plan: any){
    var porcentaje = undefined;
    var color = '';
    if(eje === 0 && plan !== 0 /* && this.dataService.company_name === 'Unión Popular'*/){//'Raiffeisen Latina' ){//
      return 'bordeNegro';
    }else if(eje === 0 && plan !== 0){
      porcentaje = 0;
    }else if(eje !== 0 && eje !== null){
      porcentaje = eje*100/plan;
      
    }
    if(porcentaje !== undefined){
      var valfin = 0;
      for(const sem of this.semaforo){
        if(valfin < sem.valfin){
          valfin = sem.valfin
        }
      }
      if(porcentaje >= valfin){
        porcentaje = valfin-1;
      }
      for(const sem of this.semaforo){
        var ab = sem.valIn;
        if(ab !== 0){
          ab = ab-0.1;
        }
        if(porcentaje >= ab && porcentaje <= sem.valfin){
          color = sem.color;
          break;
        }
      }
      switch(color){
        case 'verde': return 'bordeVerde';
        case 'azul': return 'bordeAzul';
        case 'amarillo': return 'bordeAmarillo';
        case 'naranja': return 'bordeNaranja';
        case 'rojo': return 'bordeRojo';
        default:  return 'bordeGrey';
      }
    }
    return 'bordeGris'
  }
  public pintarBordPro(eje: any, plan: any){
    if(eje !== 0){
      var color = '';
      var por = eje*100/plan;
      var valfin = 0;
      for(const sem of this.semaforo){
        if(valfin < sem.valfin){
          valfin = sem.valfin
        }
      }
      if(por >= valfin){
        por = valfin-1;
      }
      for(const sem of this.semaforo){
        var ab = sem.valIn;
        if(ab !== 0){
          ab = ab-0.1;
        }
        if(por >= ab && por <= sem.valfin){
          color = sem.color;
          break;
        }
      }
      switch(color){
        case 'verde': return 'bordeVerde';
        case 'azul': return 'bordeAzul';
        case 'amarillo': return 'bordeAmarillo';
        case 'naranja': return 'bordeNaranja';
        case 'rojo': return 'bordeRojo';
        default:  return 'bordeGrey';
      }
    }
    return 'bordeGris'
  }
  /* Fechas */
  private obtFech(isodate: any){ 
    const fecha = isodate.split('T')[0];
    var fech = new Date(fecha.split('-')[1]+'/'+fecha.split('-')[2]+'/'+fecha.split('-')[0]);
    return fech;
  }
  /* Filtros */
  public async anioChange(per: any){
    for(const an of this.aniosDisponibles){
      for(const mes of an.series){
        mes.periodo === per.periodo? mes.check = true: mes.check = false;        
        mes.periodo === per.periodo? this.Periodo = mes.periodo: '';
        mes.periodo === per.periodo? this.mesMos = mes.mes: '';
        mes.periodo === per.periodo? this.aniMos = mes.anio : '';
      }
    }
    this.expandirProg = false
    this.proyectosMostrar = [];
    try{
      this.obtenerProyectosPeriodo();
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  public persChange(pers: any){
    if(pers !== 'consolidado'){
      this.responsables.forEach(res =>{ res.name === pers.name? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.responsables.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.responsables.length){
        this.todasPer = true
      }else{
        this.todasPer = false;
      }
    }else{
      if(this.todasPer){
        this.responsables.forEach(res =>{ res.check = false});
      }else{
        this.responsables.forEach(res =>{ res.check = true});
      }
      this.todasPer = !this.todasPer
      
    }
    if( pers !== undefined || this.todasPer){
      this.obtenerProy('all');
    }
  }
  public persChangeAct(pers: any){
    if(pers != 'consolidado'){
      this.responsablesAct.forEach(res =>{ res.name === pers.name? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.responsablesAct.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.responsablesAct.length){
        this.todasPerAct = true
      }else{
        this.todasPerAct = false;
      }
    }else{
      if(this.todasPerAct){
        this.responsablesAct.forEach(res =>{ res.check = false});
      }else{
        this.responsablesAct.forEach(res =>{ res.check = true});
      }
      this.todasPerAct = !this.todasPerAct
    }
  }
  public selecAllPer(){
    for(const per of this.responsables){
      if(this.todasPer){
        per.check = false;
      }else{
        per.check = true;
      }
    }
    this.todasPer = !this.todasPer;
    if(this.todasPer){
      this.obtenerProy('all');
    }
  }
  public selecAllPerAct(){
    for(const per of this.responsablesAct){
      if(this.todasPerAct){
        per.check = false;
      }else{
        per.check = true;
      }
    }
    this.todasPerAct = !this.todasPerAct;
  }
  public lidSelec(){
    var selec = 0;
    for(const res of this.responsables){
      if(res.check){
        selec++;
      }
    }
    if(selec > 1)
      return true;
    return false;
  }
  public perPrograma(pro: any){
    for(const objPro of pro.objectives){
      if(this.objSelect === objPro.id){
        return true;
      }
    }
    return false;
  }
  public cambioPer(){
    this.objSelect = '';
    this.proSelect = '';

    this.perspectiva = this.perspectives.filter(res => res.id === this.perSelect)[0].name;
    this.objetivo = '';
    this.programa = '';

    this.obtenerProy('cam');
    this.obtenerResponsablesDin();
  }
  public cambioObj(){
    this.proSelect = '';

    this.objetivo = this.objectives.filter(res => res.id === this.objSelect)[0].name;
    this.programa = '';

    this.obtenerProy('cam');
    this.obtenerResponsablesDin();
  }
  public cambioEst(){
    this.programa = this.programas.filter(res => res.id === this.proSelect)[0].name;

    this.obtenerProy('cam');
    this.obtenerResponsablesDin();
  }
  /* Obtención de proyectos */
  private obtenerProy(zon){
    var auxmos = [];
    for(const pro of this.proyectosFin){
      switch(zon){
        case 'all':
          if(this.mostrarConResponsables(pro)){
            auxmos.push(pro)
          }
        break;
        case 'cam':
          if(this.mostrar(pro)){
            auxmos.push(pro)
          }
        break;
      }
    }
    this.proyectosMostrar = auxmos;

    for(const pro of this.proyectosMostrar){
      pro.ejecutado = this.escribirDatPro(pro,'ejec');
      pro.planeado = this.escribirDatPro(pro,'plan');
    }
    this.ordenamientoNuevo();
  }
  public mostrar(pro: any){
    var perSelected = this.anSelected();
    var perIni = Number(pro.fecha_ini.format('YYYY'));
    var perFin = Number(pro.fecha_fin.format('YYYY'));
    
    var tieneAct = false;
    var actTiene = 0;
    for(const act of pro.actividades){
      if(act.editable){
        actTiene++;
      }
    }
    if(actTiene!==0){
      tieneAct = true;
    }
    /** Verificación del periodo */
    var existPer = false;//
    if(!this.mostrarPeriodo){
      existPer = Meses.compararAnio(perIni, perFin, perSelected);
    }
    /** Verificar los objetivos */
    var selObj = false;
    if(this.objSelect !== ''){
      for( const obj of pro.proyecto.objectives){
        if(obj.id === this.objSelect){
          selObj = true;
        }
      }
    }else{
      selObj = true
    }
    /** Verificar los programas */
    var selProg = false;
    if(this.proSelect !== ''){
      if(pro.proyecto.strategies.length !== 0 && Number(pro.proyecto.strategies[0].id) === Number(this.proSelect)){
        selProg = true;
      }
    }else{
      selProg = true;
    }

    if(existPer && selObj && selProg && this.pertenece_perspective(pro) ){
      return true;
    }else if(tieneAct && selObj && selProg && this.pertenece_perspective(pro)){
      return true;
    }
    return false;
  }
  public mostrarConResponsables(pro: any){
    var perSelected = this.anSelected();
    var perIni = Number(pro.fecha_ini.format('YYYY'));
    var perFin = Number(pro.fecha_fin.format('YYYY'));
    var tieneAct = false;
    var actTiene = 0;
    for(const act of pro.actividades){
      if(act.editable){
        actTiene++;
      }
    }
    if(actTiene!==0){
      tieneAct = true;
    }
    /** verificación del periodo */
    var existPer = false;//

    if(!this.mostrarPeriodo){
      existPer = Meses.compararAnio(perIni, perFin, perSelected);
    }    
    /** verificación del lider */
    var existeLid = false;
    for(const res of this.responsables){
      if(res.id === pro.proyecto.responsible.id && res.check){
        existeLid = true;
      }
    }
    /** Verificar los objetivos */
    var selObj = false;
    if(this.objSelect !== ''){
      for( const obj of pro.proyecto.objectives){
        if(obj.id === this.objSelect){
          selObj = true;
        }
      }
    }else{
      selObj = true
    }
    /** Verificar los programas */
    var selProg = false;
    if(this.proSelect !== ''){
      if(pro.proyecto.strategies[0].id === this.proSelect){
        selProg = true;
      }
    }else{
      selProg = true;
    }
    /* Verificar si tiene actividades */
    var tieneActividades = true, acc = 0;
    for(const act of pro.actividades){
      if(this.resSelected(act) && (act.editable || !this.mostrarPeriodo)){
        acc++;
      }
    }
    if(acc===0){
      tieneActividades = false
    }

    if(tieneActividades && existPer && selObj && existeLid && selProg && this.pertenece_perspective(pro) ){
      return true;
    }else if(tieneActividades && tieneAct && selObj && existeLid && selProg && this.pertenece_perspective(pro)){
      return true;
    }
    return false;
  }
  /* Pertenece a la perspectiva */
  private pertenece_perspective(pro: any){
    if(this.perSelect !== ''){
      var obj = [];
      for(const obje of pro.proyecto.objectives){
        const om = this.objectives.filter(obb => obb.id === obje.id);
        obj = obj.concat(om);
      }
      const ex = obj.filter(obj => obj.perspective.id === this.perSelect)
      if( ex.length !== 0 ){
        return true;
      }
      return false;
    }else{
      return true;
    }
  }
  /* Abrir y cerrar los proyectos */
  public oculMost(pro: any){
    pro.check = !pro.check;
    var check = 0;
    for(const pro of this.proyectosMostrar){
      if(pro.check){
        check++;
      }
    }
    if(check === this.proyectosMostrar.length){
      this.expandirProg = true;
    }else if(check === 0){
      this.expandirProg = false;
    }
  }
  public oculMostAll(){
    for(const pro of this.proyectosMostrar){
      if(this.expandirProg){
        pro.check = false;
      }else{
        pro.check = true;
      }
    }
    this.expandirProg = !this.expandirProg;
  }
  public resSelected(act){
    var existeLid = false;
    for(const res of this.responsablesAct){
      if(res.id === act.responsible.id && res.check){
        existeLid = true;
      }
    }
    return existeLid;
  }
  //Escritura de datos
  public escribir_fecha(fecha: any){
    var fech;
    fech = moment(fecha).format('DD MMM YY')
    return fech;
  }
  public obtenerDias(fIni: any, fFin: any){
    var dias = 0;
    var diff = fFin.diff(fIni, 'days');
    if(diff === 0){
      diff = 1;
    }
    switch(this.diasLab){
      case 'Lunes-Viernes':
        var sem = Math.trunc(diff/7);
        dias = diff - sem*2;
      break;
      case 'Lunes-Sabado':
        var sem = Math.trunc(diff/7);
        dias = diff - sem;
      break;
      case 'Lunes-Domingo':
        dias = diff;
      break;
    }
    return dias;
  }
  public escribirDat(pro: any, tip: string){
    var per = this.perSelected();
    for(const dat of pro){
      if(per === dat.periodo){
        if(tip === 'plan'){
          return dat.planeado;
        }else if(tip === 'ejec'){
          return dat.ejecutado;
        }
      }
    }
  }
  public escribirDatPro(proy: any, tip: string){
    const pro = this.proyectos.filter(p => Number(p.id) === Number(proy.proyecto.id))[0];
    return this.avancesProyectos(pro, tip);
  }
  public editar(his: any, idAct: any){
    var perSel = '';
    for(const an of this.aniosDisponibles){
      for(const mes of an.series){
        if(mes.check){
          perSel = mes.periodo;
        }
      }
    }
    var perAct = Meses.obtnerPer(this.fechaAct);
    var perAnt = Meses.obtnerPerAnt(this.fechaAct);
    if(this.edicion){
      this.dat(his,perSel,idAct);
      return ;
    }else if(Meses.compararPer(perAnt,perAct,perSel)){
      this.dat(his,perSel,idAct)
    }else{
      messages.infoMessageGraph(this.translate.instant('gestion.seguimiento.proy-estra.editInfo'))
    }    
  }
  private obtenerActividadUnica(response, idAct,acc){
    var aux = [];
    var auxAct;
    for(var act of this.actividadesFull){
      if(Number(act.id) === Number(idAct)){
        var hist = [];
        var historicosCom = Meses.obtenerPlaneado(this.obtFech(act.initial_date), this.obtFech(act.end_date), this.diasLab);
        let hisAg = 0;
        for(const his of historicosCom){
          const ex = response.historic.filter(h => h.period === his.periodo);
          if(ex.length !== 0){
            hist.push({
              periodo: ex[0].period,
              planeado: Number(ex[0].planned),
              ejecutado: ex[0].executed,
              id: ex[0].id,
            });
            hisAg++;
          }else{
            hist.push({
              periodo: his.periodo,
              planeado: Number(his.planeado),
              ejecutado: his.ejecutado,
              id: his.id,
            });
          }
        }
        if(hisAg !== response.historic.length){
          for(const h of response.historic){
            const ex = hist.filter(hi => hi.periodo === h.period);
            if(ex.length === 0){
              hist.push({
                periodo: h.period,
                planeado: Number(h.planned),
                ejecutado: h.executed,
                id: h.id,
              });
            }
          }
        }
        aux.push({
          additions: [],
          end_date: act.end_date,
          id: act.id,
          initial_date: act.initial_date,
          name: act.name,
          project: act.project,
          responsible: act.responsible,
          historico: hist,
          completed: response.completed
        });
        auxAct = {
          additions: [],
          end_date: act.end_date,
          id: act.id,
          initial_date: act.initial_date,
          name: act.name,
          project: act.project,
          responsible: act.responsible,
          historico: hist,
          completed: response.completed
        }
        const pro = this.proyectos.filter(p => Number(p.id) === Number(act.project.id))[0];
        const a = pro.activities.filter(a => Number(a.id) === Number(act.id))[0];
        a.historico = hist;
      }else{
        aux.push(act);
      }
    }
    this.actividadesFull = aux;
    if(acc === 'p'){
      for(const pro of this.proyectosMostrar){
        for(const act of pro.actividades){
          if(Number(act.id) === Number(idAct)){
            const his = this.obtenerHistorico(auxAct)
            act.historico = [].concat([his])
          }
        }
      }
    }
    for(const pro of this.proyectosMostrar){
      pro.ejecutado = this.escribirDatPro(pro,'ejec');
      pro.planeado = this.escribirDatPro(pro,'plan');
    }
  }
  public async dat(his: any, perSel: any, idAct: any){
    var inputValue = 0, introdujo: any, guardo = false;
    
    for(const per of his){
      if(per.periodo === perSel){
        inputValue = per.ejecutado;
      }
    }

    introdujo = await Swal.fire({
      title: this.translate.instant('gestion.seguimiento.proy-estra.ingresaValor'),
      text: "",
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (Number(value) > 100) {
          return this.translate.instant('gestion.seguimiento.proy-estra.valorMayor');
        }
        if (Number(value) === 100 && Number(his[0].planeado) !== 100) {
          return this.translate.instant('gestion.seguimiento.proy-estra.noComp');
        }
        guardo = true;
        return '';
      }
    });

    try{
      if(guardo && his[0].id !== 0){
        messages.messageSaving(this.translate.instant('swal.editandoInfo'),this.translate.instant('swal.espere'));
        for(const per of his){
          if(per.periodo === perSel){            
              if(introdujo.value !== ''){
                per.ejecutado = Number(introdujo.value);
                const res = await firstValueFrom(this.actividadService.PatchHistorico(per, Number(idAct),Number(per.id))); 
                const res2 = await firstValueFrom(this.actividadService.getActividadesId(Number(idAct))); 
                this.obtenerActividadUnica(res2, idAct, 'e');
                Swal.close();
                messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
              }else{
                const res = await firstValueFrom(this.actividadService.DeleteHistorico(per, Number(idAct),Number(per.id))); 
                const res2 = await firstValueFrom(this.actividadService.getActividadesId(Number(idAct))); 
                this.obtenerActividadUnica(res2, idAct,'p');
                messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));
              }
          }
        }
      }else if(guardo && his[0].id === 0){
        his[0].ejecutado = Number(introdujo.value);
        var hist = his[0];
        const res = await firstValueFrom(this.actividadService.postHistorico(hist, Number(idAct))); 
        const res2 = await firstValueFrom(this.actividadService.getActividadesId(Number(idAct))); 
        this.obtenerActividadUnica(res2, idAct, 'p');
        his[0].id = res.id;
        Swal.close();
        messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));       
      }
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  public escribirAdicional(adic: any){
    if(adic != undefined){
      switch(adic.type){
        case 'texto':
          return this.obtComment(adic.comments);
        case 'moneda':
          return this.formatearnormal(adic.amount);
        case 'numero':
          return this.obtCommentNumero(adic.comments);
        case 'archivo':
          var per  = this.perSelected();
          for(const file of adic.files){
            if( per === Meses.obtnerPer(new Date(file.createdAt))){
              return file.name.split('-')[file.name.split('-').length - 1];
            }
          }
          return '';
      }
    }
  }
  private obtCommentNumero(com : any){
    for(const comen of com){
      var per = 0;
      for(const an of this.aniosDisponibles){
        for(const mes of an.series){
          if(mes.check){
            per = an.anio;
          }
        }
      }
      var percom = new Date(comen.createdAt).getFullYear();
      if(per === percom){
        return comen.comment;
      } 
    }
    return '';
  }
  private obtComment(com : any){
    for(const comen of com){
      var per =  this.perSelected();
      const fecha = moment(comen.createdAt.split('T')[0]);
      var percom = Meses.getMesesN(fecha.month()+1) + '-' +(''+fecha.year()).substring(2,4);
      if(per === percom){
        return comen.comment;
      }
    }
    return '';
  }
  public async edicionAd(adic: any, id: any, event?: any){
    var inputValue : any, introdujo: any, guardo = false;

    switch(adic.type){
      case 'texto':
        inputValue =  this.obtComment(adic.comments);
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.proy-estra.ingComen'),
          text: "",
          input: 'text',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            guardo = true;
            return '';
          }
        });
        break;
      case 'moneda':
        inputValue =  adic.amount;
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.proy-estra.ingMonto'),
          text: "",
          input: 'number',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            if (!value) {
              return this.translate.instant('gestion.seguimiento.proy-estra.datoInvalido');
            }
            guardo = true;
            return '';
          }
        });
      break;
      case 'archivo':
        inputValue =  adic.file;
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.proy-estra.selecArch'),
          text: "",
          input: 'file',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            if (!value) {
              return this.translate.instant('gestion.seguimiento.proy-estra.datoInvalido');
            }
            guardo = true;
            return '';
          }
        });
      break;
    }

    if(guardo){
      try{
        messages.messageSaving(this.translate.instant('swal.editandoInfo'),this.translate.instant('swal.espere'));
        switch(adic.type){
          case 'texto':
            var existe = false;
            var per =  this.perSelected();
            var c = 0;
            for(const comen of adic.comments){
              const fecha = moment(comen.createdAt.split('T')[0]);
              var percom = Meses.getMesesN(fecha.month()+1) + '-' +(''+fecha.year()).substring(2,4);
              if(per === percom){
                existe = true;
                if(introdujo.value === ''){
                  introdujo.value = ' ';
                  const res = await firstValueFrom(this.adicionalService.deleteComment(comen, adic.id)); 
                  messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
                  const pr = this.proyectos.find(p => p.activities.find(a => a.id === id));
                  const ac = pr.activities.find(a => a.id === id);
                  const adG = ac.additions.find(a => a.id === adic.id);
                  adG.comments = adG.comments.filter(c => c.id !== comen.id);
                  adic.comments = adic.comments.filter(c => c.id !== comen.id);
                }else{
                  comen.comment = introdujo.value;
                  const pr = this.proyectos.find(p => p.activities.find(a => a.id === id));
                  const ac = pr.activities.find(a => a.id === id);
                  const adG = ac.additions.find(a => a.id === adic.id);
                  const coment = adG.comments.find(c => c.id === comen.id);
                  coment.comment = introdujo.value;
                  const res = await firstValueFrom(this.adicionalService.patchComment(comen, adic.id)); 
                  messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
                }
                c++;
              }
            }
            if(!existe && introdujo.value !== ''){
              var date = (new Date(Meses.getMesesS(per.split('-')[0])+'-1-'+per.split('-')[1]));
              let aux = {
                comment: introdujo.value,
                createdAt: date.toISOString()
              }
              
              const res = await firstValueFrom(this.adicionalService.postComment(aux, adic.id));
              const pr = this.proyectos.find(p => p.activities.find(a => a.id === id));
              const ac = pr.activities.find(a => a.id === id);
              const adG = ac.additions.find(a => a.id === adic.id);
              adG.comments.push({id: res.id, ...aux});
              adic.comments.push({id: res.id, ...aux});
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
            }else if(!existe){
              messages.cancelMessage(this.translate.instant('swal.cancelado'))
            }
            break;
          case 'moneda':
            adic.amount = introdujo.value;
            const res = await firstValueFrom(this.adicionalService.patchAdicionalesValues(adic)); 
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
            break;
          case 'archivo':
            this.progressInfo = [];
            introdujo.value ? this.imageName = introdujo.value.name : this.imageName = introdujo.value.length + " archivos";
            this.selectedFiles = introdujo.value;
            var per  = this.perSelected();
            var existe = false;
            if( this.selectedFiles["size"] > obtenerTamMax.getPeso() ){
              messages.errorMessageGraph(obtenerTamMax.getTexto())
              this.edicionAd(adic, id,event);
            }else{
              if(!existe){
                var per = this.perSelected();
                const fecha = new Date(Meses.getMesesS(per.split('-')[0])+'/1/'+per.split('-')[1]);
                
                const res = await firstValueFrom(this.adicionalService.postFile(this.selectedFiles, adic.id, fecha.toISOString()));
                let aux = {
                  id: res.id,
                  name: res.name,
                  description: res.description,
                  path: res.path,
                  createdAt: fecha.toISOString()
                }
                const pr = this.proyectos.find(p => p.activities.find(a => a.id === id));
                const ac = pr.activities.find(a => a.id === id);
                const adG = ac.additions.find(a => a.id === adic.id);
                adG.files.push({ ...aux});
                adic.files.push({ ...aux});
                Swal.close();
                messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
              }
            }
          break;
        }
      }catch(err){
        Swal.close();
        messages.errorMessageGraph(err);
      }      
    }else{
      messages.cancelMessage(this.translate.instant('swal.cancelado'));
    }
  }
  public async abirPDF(ad, event?: any){
    const per = this.perSelected();
    for(const fil of ad.files){
      if(Meses.obtnerPer(new Date(fil.createdAt)) === per){
        try{
          const response = await firstValueFrom(this.adicionalService.getFile(ad.id, fil.id)); 
          switch(fil.name.split('.')[fil.name.split('.').length-1]){
            case 'pdf':
              const mediaType = 'application/pdf';
              const blob = new Blob([response], { type: mediaType });
              const nav = (window.navigator as any);

              if (nav.msSaveOrOpenBlob)  {
                nav.msSaveOrOpenBlob(blob, fil.name);
              } else {
                const a = document.createElement('a');
                const url = URL.createObjectURL(blob);
                a.href = url;
                a.download = fil.name;
                document.body.appendChild(a);
                window.open(""+a.href,"_blank");

                setTimeout(function() {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);  
                }, 0); 
              }
            break;
            case 'png':
            case 'jpg':
              const mediaTypei = 'image/'+fil.name.split('.')[fil.name.split('.').length-1];
              const blobi = new Blob([response], { type: mediaTypei });
              const navi = (window.navigator as any);

              if (navi.msSaveOrOpenBlob)  {
                navi.msSaveOrOpenBlob(blobi, fil.name);
              } else {
                const a = document.createElement('a');
                const url = URL.createObjectURL(blobi);
                a.href = url;
                a.download = fil.name;
                document.body.appendChild(a);
                window.open(""+a.href,"_blank");
                a.click();

                setTimeout(function() {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);  
                }, 0); 
              }
            break;
            default:
              const mediaTyped = 'aplication/'+fil.name.split('.')[fil.name.split('.').length -1];
              const blobd = new Blob([response], { type: mediaTyped });
              const navd = (window.navigator as any);

              if (navd.msSaveOrOpenBlob)  {
                navd.msSaveOrOpenBlob(blobd, fil.name);
              } else {
                const a = document.createElement('a');
                const url = URL.createObjectURL(blobd);
                a.href = url;
                a.download = fil.name.split('-')[fil.name.split('-').length -1];
                document.body.appendChild(a);
                a.click();

                setTimeout(function() {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);  
                }, 0); 
              }
            break;
          }
        }catch(err){
          messages.errorMessageGraph(err);
        }
      }
    }
  }
  public escribirAdicionalPro(pro: any, i: number){
    var presTot = 0;
    var presTotN = 0;
    for(const act of pro){
      for(const ad of act.additions){
        if(ad.type === 'moneda'){
          presTot += Number(ad.amount);
        }
      }
    }
    if(this.actividades[0].additions[i].type === 'moneda'){
      return this.formatearnormal(presTot);
    }else{
      return '';
    }
  }
  //eliminar archivos
  public async deleteArchivo(){
    const per = this.perSelected();
    const result = await messages.confirmationSave(
      this.translate.instant('gestion.seguimiento.proy-estra.eliminarArch'),
      this.translate.instant(''),
      this.translate
    );
    if (result) {
      try{
        messages.messageSaving(this.translate.instant('swal.eliminandoInfo'),this.translate.instant('swal.espere'));
        for(const fil of this.adDelete.files){
          if(Meses.obtnerPer(new Date(fil.createdAt)) === per){
            const pr = this.proyectos.find(p => p.activities.find(a => a.id === this.adActivi.id));
            const ac = pr.activities.find(a => a.id === this.adActivi.id);
            const adG = ac.additions.find(a => a.id === this.adDelete.id);
            adG.files = adG.files.filter(f => f.id !== fil.id);
            this.adDelete.files = this.adDelete.files.filter(f => f.id !== fil.id);
            const res = await firstValueFrom(this.adicionalService.deleteFile(this.adDelete.id, fil.id));
            messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));  
          }
        }
      }catch(err){
        messages.errorMessageGraph(err);
      }        
    }
  }  
  // Metodos de busqueda
  private perSelected(){
    for(const an of this.aniosDisponibles){
      for(const mes of an.series){
        if(mes.check){
          return mes.periodo;
        }
      }
    }
    return '';
  }
  private anSelected(){
    for(const an of this.aniosDisponibles){
      for(const mes of an.series){
        if(mes.check){
          return an.anio;
        }
      }
    }
    return '';
  }
  // Metodos de ordenamiento
  public ordenamientoId(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public ordenamientoSem(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.value_00) > Number(b.value_00)) {
        return 1;
      }
      if (Number(a.value_00) < Number(b.value_00)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public ordenamientoIdSort(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.proyecto.id) > Number(b.proyecto.id)) {
        return 1;
      }
      if (Number(a.proyecto.id) < Number(b.proyecto.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  private ordenamientoAlf(array: any){
    array.sort(function (a: any, b: any) {
      if ( a.name.toLowerCase() > b.name.toLowerCase() ) {
        return 1;
      }
      if ( a.name.toLowerCase() < b.name.toLowerCase() ) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  private ordenamientoAlfAsc(array: any){
    array.sort(function (a: any, b: any) {
      if ( a.proyecto.name.toLowerCase() > b.proyecto.name.toLowerCase() ) {
        return 1;
      }
      if ( a.proyecto.name.toLowerCase() < b.proyecto.name.toLowerCase() ) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  private ordenamientoAlfDes(array: any){
    array.sort(function (a: any, b: any) {
      if ( a.proyecto.name.toLowerCase() < b.proyecto.name.toLowerCase() ) {
        return 1;
      }
      if ( a.proyecto.name.toLowerCase() > b.proyecto.name.toLowerCase() ) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public ordenamientoObjId(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.objectives[0].id) > Number(b.objectives[0].id)) {
        return 1;
      }
      if (Number(a.objectives[0].id) < Number(b.objectives[0].id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public ordenamientoAd(array: any){
    array.sort(function (a: any, b: any) {
      if (a.name > b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public ordenamientoPlaneado(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.planeado) > Number(b.planeado)) {
        return 1;
      }
      if (Number(a.planeado) < Number(b.planeado)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  private ordenamientoHis(array){
    array.sort(function (a: any, b: any) {
      let af = moment(Meses.escrituraPer(a.periodo), 'MM/DD/YY');
      let bf = moment(Meses.escrituraPer(b.periodo), 'MM/DD/YY');
      if (bf.isBefore(af)) {
        return 1;
      }
      if (af.isBefore(bf)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  //Rutas
  public rutas(direc: string){
      this.router.navigateByUrl('/app/'+ 'seguimiento/' + 'programas/' +this.idPlanificacion);
  }
  //Formatear datos
  public formatearnormal(num: any){
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    return  splitLeft;
  }
  // Avance acumulado
  public avanceAcumulado(act: any){
    var valFin = 0;
    var res = this.actividadesFull.filter(ac => ac.id === act.id);
    if(res.length !== 0){
      var hist = res[0].historico;
      hist = this.ordenamientoId(hist);
      hist = this.ordenamientoPlaneado(hist);
      for(const h of hist){
        if(act.historico[0].periodo !== h.periodo){
          if(h.ejecutado !== null){
            valFin = h.ejecutado;
          }
        }else{
          if(h.ejecutado !== null){
            valFin = h.ejecutado;
          }
          break;
        }
      }
    }
    return valFin;
  }
  //Exportar excel
  public exportar_excel(){
    if(this.programa !== ''){
      var title = this.translate.instant('gestion.seguimiento.proy-estra.titExcel')+' | ' + this.perspectiva + ' | ' + this.objetivo + ' | ' + this.programa + ' | ' + this.Periodo;
    }else if(this.objetivo !== ''){
      var title = this.translate.instant('gestion.seguimiento.proy-estra.titExcel')+' | ' + this.perspectiva + ' | ' + this.objetivo + ' | ' + this.Periodo;
    }else if(this.perspectiva !== ''){
      var title = this.translate.instant('gestion.seguimiento.proy-estra.titExcel')+' | ' + this.perspectiva + ' | ' + this.Periodo;
    }else{
      var title = this.translate.instant('gestion.seguimiento.proy-estra.titExcel')+' | ' + this.Periodo;
    }
    var header = [this.translate.instant('gestion.seguimiento.proy-estra.encExcel1'), this.translate.instant('gestion.seguimiento.proy-estra.encExcel2'), 
    this.translate.instant('gestion.seguimiento.proy-estra.titTab1'), this.translate.instant('gestion.seguimiento.proy-estra.titTab2'), 
    this.translate.instant('gestion.seguimiento.proy-estra.titTab3'),this.translate.instant('gestion.seguimiento.proy-estra.titTab4'),
    this.translate.instant('gestion.seguimiento.proy-estra.titTab5'),this.translate.instant('gestion.seguimiento.proy-estra.titTab7'), 
    this.translate.instant('gestion.seguimiento.proy-estra.titTab8')];
    for(var j = 0; j < this.actividades[0].additions.length; j++){
      header.push( "" + this.actividades[0].additions[j].name );
    }
    var data = [];
    var aux = [];
    for(var i = 0; i < this.proyectosMostrar.length; i++){
      const ob = this.objectives.filter(o => o.id === this.proyectosMostrar[i].proyecto.objectives[0].id)[0]
      aux.push(ob.perspective.name);
      aux.push(ob.name);
      aux.push( this.proyectosMostrar[i].proyecto.name );
      aux.push(this.proyectosMostrar[i].fecha_ini.format('DD/MMM/YYYY'));
      aux.push( this.obtenerDias(this.proyectosMostrar[i].fecha_ini,this.proyectosMostrar[i].fecha_fin) );
      aux.push(this.proyectosMostrar[i].fecha_fin.format('DD/MMM/YYYY'));
      aux.push( this.proyectosMostrar[i].proyecto.responsible.position );
      aux.push( this.escribirDatPro(this.proyectosMostrar[i],'plan') );
      aux.push( this.escribirDatPro(this.proyectosMostrar[i],'eje') );
      for(var j = 0; j < this.actividades[0].additions.length; j++){
        aux.push( this.escribirAdicionalPro(this.proyectosMostrar[i].actividades,j) );
      }
      data.push(aux);
      aux = [];
      for(const act of this.proyectosMostrar[i].actividades){
        if(this.resSelected(act) && (act.editable || !this.mostrarPeriodo) ){
          const ob2 = this.objectives.filter(o => o.id === this.proyectosMostrar[i].proyecto.objectives[0].id)[0]
          aux.push(ob2.perspective.name);
          aux.push(ob2.name);
          aux.push( '-'+act.name );
          aux.push(act.initial_date.format('DD/MMM/YYYY'));
          aux.push( this.obtenerDias(act.initial_date,act.end_date) );
          aux.push(act.end_date.format('DD/MMM/YYYY'));
          aux.push( act.responsible.position );
          aux.push( this.escribirDat(act.historico, 'plan')==='-'? '0.0':this.escribirDat(act.historico, 'plan'));
          aux.push( (this.escribirDat(act.historico, 'ejec')===null || this.escribirDat(act.historico, 'ejec')==='-')? 'null':this.escribirDat(act.historico, 'ejec') );
          for(const ad of act.additions){
            aux.push( this.escribirAdicional(ad) );
          }
          data.push(aux);
          aux = [];
        }
      }
    }
    const NomArch = this.translate.instant('gestion.seguimiento.proy-estra.nombreExcel1');
    this.excelService.generateExcelProyectos(title, header, data, NomArch, this.semaforo);
  }
  public async exportar_excelPer(){ // checar
    var años = [];
    var selecciono = false, anio = '';

    this.aniosDisponiblesTot.forEach(an => años.push(an.anio));
    const result = await messages.select(
      this.translate.instant('gestion.seguimiento.proy-estra.selecAnio'),
      años,
      this.translate
    );
    if(result){
      anio = años[result];
      selecciono = true;
      Swal.close();
    }
    if(selecciono){
      var activities = [], proyects = [];
      for(const act of this.actividadesFull){
        let fecFin = moment(act.end_date.split('T')[0]).format('YYYY'), fecIn = moment(act.initial_date.split('T')[0]).format('YYYY');
        if( Number(fecIn) === Number(anio) || Number(fecFin) === Number(anio)){
          let idPro = Number(act.project.id), namePro = act.project.name;
          let existe = proyects.filter(pro => pro.id === idPro);
          if(existe.length === 0){
            proyects.push({
              id: idPro,
              name: namePro,
            })
          }
          activities.push({
            nombre: act.name,
            proyectoId: idPro,
            responsable: act.responsible,
            historico: act.historico,
            id: act.id,
            fechaIni: fecIn,
            fechaFin: fecFin
          });
        }
      }
      for(const pro of proyects){
        let actividades = activities.filter(act => pro.id === act.proyectoId);
        pro.actividades = actividades;        
      }
      var aux = [], data = [];
      var header = [this.translate.instant('gestion.seguimiento.proy-estra.encExcel1'), this.translate.instant('gestion.seguimiento.proy-estra.encExcel2'), 
      this.translate.instant('gestion.seguimiento.proy-estra.titTab1'),this.translate.instant('gestion.seguimiento.proy-estra.titTab2'),
      this.translate.instant('gestion.seguimiento.proy-estra.titTab3'),this.translate.instant('gestion.seguimiento.proy-estra.titTab4'),
      this.translate.instant('gestion.seguimiento.proy-estra.titTab10'),this.translate.instant('gestion.seguimiento.proy-estra.titTab6')];
      var title = this.translate.instant('gestion.seguimiento.proy-estra.titExcel2')+' | ' + anio + ' |  '+this.translate.instant('gestion.seguimiento.proy-estra.titTab61');
      for(const pro of proyects){
        const pr = this.proyectos.filter( p => Number(p.id) === Number(pro.id))[0]
        const ob = this.objectives.filter(o => o.id === pr.objectives[0].id)[0]
        aux.push(ob.perspective.name);
        aux.push(ob.name);
        aux.push(pro.name);
        aux.push('');
        aux.push('');
        aux.push('');
        aux.push('');
        aux.push('');
        data.push(aux);
        aux = [];
        for(const act of pro.actividades){
          const pr2 = this.proyectos.filter( p => Number(p.id) === Number(pro.id))[0]
          const ob2 = this.objectives.filter(o => o.id === pr2.objectives[0].id)[0]
          aux.push(ob2.perspective.name);
          aux.push(ob2.name);
          let avan = this.avanceAcumuladoExport(act, 'dic-'+(anio+'').substring(2))
          aux.push('-'+act.nombre);
          aux.push(moment(act.fechaIni).format('DD/MMM/YYYY'));
          aux.push( this.obtenerDias(moment(act.fechaIni),moment(act.fechaFin)) );
          aux.push(moment(act.fechaFin).format('DD/MMM/YYYY'));
          aux.push( act.responsable.position );
          aux.push(avan);
          data.push(aux);
          aux = [];
        }
        aux.push('');
        aux.push('');
        aux.push('-');
        aux.push('');
        aux.push('');
        aux.push('');
        aux.push(''); 
        aux.push('');
        data.push(aux);
        aux = [];
      }
      const NomArch = this.translate.instant('gestion.seguimiento.proy-estra.nombreExcel1');
      this.excelService.generateExcelProyectos(title, header, data, NomArch, this.semaforo);
    }
  }
  public avanceAcumuladoExport(act: any, per: any){
    var valFin = 0;
    var hist = act.historico;
    hist = this.ordenamientoId(hist);
    hist = this.ordenamientoPlaneado(hist);
    for(const h of hist){
      if(per !== h.periodo){
        if(h.ejecutado !== null){
          valFin = h.ejecutado;
        }
      }else{
        if(h.ejecutado !== null){
          valFin = h.ejecutado;
        }
        break;
      }
    }
    return valFin;
  }
  public exportarExcelTodo(){
    const fontSize = 10;
    const header = [this.translate.instant('gestion.seguimiento.proy-estra.titTab1'), this.translate.instant('gestion.seguimiento.proy-estra.titTab5'), 
    this.translate.instant('gestion.seguimiento.proy-estra.titTab2'),this.translate.instant('gestion.seguimiento.proy-estra.titTab4'),
    this.translate.instant('gestion.seguimiento.proy-estra.titTab7'),this.translate.instant('gestion.seguimiento.proy-estra.titTab8'), 
    this.translate.instant('gestion.seguimiento.proy-estra.titTab9')] 
    const auxData = [];
    for (const pro of this.proyectos) {      
        const ejec = this.avancesProyectos(pro, 'ejec');
        const plan = this.avancesProyectos(pro, 'plan');
        let aux = [];
        if( plan !== 0 ){
          const fech = this.obtenerFechasPro(pro);
          aux.push(pro.name);
          aux.push(pro.responsible.position);
          aux.push(fech[0]);
          aux.push(fech[1]);
          aux.push(plan);
          aux.push(ejec);
          aux.push( this.estatus( this.pintarBordPro(ejec,plan) ) );
          auxData.push(aux);
          aux = [];
          for(const act of pro.activities){
            const ejecA =  this.avancesProyectosActividad(act, 'ejec');
            const planA =  this.avancesProyectosActividad(act, 'plan');
            aux.push('-'+act.name);
            aux.push(act.responsible.position);
            aux.push(act.initial_date.format('DD-MM-YYYY'));
            aux.push(act.end_date.format('DD-MM-YYYY'));
            aux.push(planA==='rep' || planA==='por'?'-':planA);
            aux.push(ejecA===null || ejecA==='rep' || ejecA==='por'?'-':ejecA);
            aux.push(this.estatus( this.pintarBord(ejecA,planA), ejecA ));
            auxData.push(aux);
            aux = [];
          }
        }
    }
    const NomArch = this.translate.instant('gestion.seguimiento.proy-estra.nombreExcel2');
    this.excelService.generateExcelProyectosAvance(NomArch, header, auxData, NomArch, this.semaforo);
  }
  private obtenerFechasPro(pro){
      var fecha_fin = undefined;
      var fecha_ini = undefined;
      for(const act of pro.activities){
        var fI = moment(act.initial_date), fF = moment(act.end_date)
        if(fecha_ini === undefined || fecha_ini.isAfter(fI)){
          fecha_ini = fI;
        }
        if(fecha_fin === undefined || fecha_fin.isBefore(fF)){
          fecha_fin = fF;
        }
        
      }

    return [fecha_ini.format('DD-MM-YYYY'), fecha_fin.format('DD-MM-YYYY')];
  }
  /** */
  public avancesProyectos(pro: any, tipo){
    var per = this.perSelected();
    var dias = 0, porcentajeplan = 0, porcentajeejec = 0;
    for(const act of pro.activities){
      dias += this.obtenerDias(act.initial_date,act.end_date);
    }
    for(const act of pro.activities){
      const fecPer = moment(Meses.escrituraPer(per));
      let historicoEva = undefined;
      if(moment(act.initial_date).isBefore(fecPer) && moment(act.end_date).isBefore(fecPer) && this.actividadIncompleta(act)){
        historicoEva = act.historico.filter(his => his.periodo === per)[0];
        if(historicoEva === undefined){
          historicoEva = {
            ejecutado: null,
            planeado: 100
          };
        }
      }else if(moment(act.initial_date).isBefore(fecPer) && moment(act.end_date).isBefore(fecPer) && !this.actividadIncompleta(act)){
        historicoEva = act.historico[act.historico.length-1];
      }else if(moment(act.initial_date).isBefore(fecPer) || moment(act.initial_date).isSame(fecPer, 'month') || moment(act.end_date).isSame(fecPer, 'month')){
        historicoEva = act.historico.filter(his => his.periodo === per)[0];
      }

      if(historicoEva !== undefined){
        var diasAct = this.obtenerDias(act.initial_date,act.end_date);
        var pesoAct = Number((diasAct*100/dias).toFixed(2));
        porcentajeplan += Number( (historicoEva.planeado*pesoAct/100).toFixed(2));
        if(historicoEva.ejecutado === null || historicoEva.ejecutado === 'null'){
          porcentajeejec += 0;
        }else{
          porcentajeejec += Number((historicoEva.ejecutado*pesoAct/100).toFixed(2));
        }
      }
    }
    
    porcentajeplan = Number(porcentajeplan.toFixed(2));
    porcentajeejec = Number(porcentajeejec.toFixed(2));
    if(porcentajeejec >= 99.98){
      porcentajeejec = 100;
    }
    if(tipo === 'ejec'){
      return porcentajeejec;
    }
    if(porcentajeplan >= 99.98){
      porcentajeplan = 100;
    }
    return porcentajeplan;
  }
  public avancesProyectosActividad(act: any, tipo){
    var per = this.perSelected();
    var porcentajeplan = 0, porcentajeejec = 0;

    const fecPer = moment(Meses.escrituraPer(per), 'MM/DD/YY');
    const actFI = act.initial_date;
    const actFF = act.end_date;
    let historicoEva = undefined;
    if(moment(actFI).isBefore(fecPer) && moment(actFF).isBefore(fecPer) && this.actividadIncompleta(act)){
      historicoEva = act.historico.filter(his => his.periodo === per)[0];
      if(historicoEva === undefined){
        if(tipo === 'ejec'){
          return null;
        }
        return 100;
      }
    }else if(moment(actFI).isBefore(fecPer) && moment(actFF).isBefore(fecPer) && !this.actividadIncompleta(act)){
      historicoEva = act.historico[act.historico.length-1];
    }else if(moment(actFI).isBefore(fecPer) || moment(actFI).isSame(fecPer, 'month')){
      historicoEva = act.historico.filter(his => his.periodo === per)[0];
    }else if(moment(actFI).isAfter(fecPer)){
      return 'por';
    }

    const adicionales = this.actividadesFull.filter( a => Number(a.id) === Number(act.id))[0].additions;
    const ad = adicionales.filter(ad => ad.type === 'texto');

    for(const adic of ad){
      for(const com of adic.comments){
        const fecha = moment(com.createdAt.split('T')[0]);
        var percom = Meses.getMesesN(fecha.month()+1) + '-' +(''+fecha.year()).substring(2,4);
        const text = com.comment.toLowerCase();
        if( percom === per &&  text.includes('reprogramada') ){
          return 'rep';
        }
      }
    }

    if(historicoEva !== undefined){
      porcentajeplan = historicoEva.planeado;
      porcentajeejec = historicoEva.ejecutado;
      if(tipo === 'ejec'){
        return porcentajeejec;
      }
      return porcentajeplan;
    }
    return '';
  }
  //
  public obtEstatus(a){
    const act = this.actividadesFull.filter( ac => Number(ac.id) === Number(a.id))[0];

    const ejecA =  this.avancesProyectosActividad(act, 'ejec');
    const planA =  this.avancesProyectosActividad(act, 'plan');

    const dat = this.estatus( this.pintarBord(ejecA,planA), ejecA );
    return dat;
  }
  public estatusAct(a){
    if(!this.allStats){
      const act = this.actividadesFull.filter( ac => Number(ac.id) === Number(a.id))[0];

      const ejecA =  this.avancesProyectosActividad(act, 'ejec');
      const planA =  this.avancesProyectosActividad(act, 'plan');

      const dat = this.estatus( this.pintarBord(ejecA,planA), ejecA );

      const est = this.estats.filter(es => es.name === dat)[0];
      if(est.check){return true}
      return false;
    }
    return true;
  }
  private estatus(col, estado?){
    if(estado === 'rep'){
      return 'Reprogramada';
    }else if(estado === 'por'){
      return 'Por iniciar';
    }
    switch(col){
      case 'bordeAzul':
      case 'bordeVerde':
        return 'Cumplida';
      case 'bordeRojo':
      case 'bordeNaranja':
        return 'Incumplida';
      case 'bordeAmarillo':
        return 'En proceso';
      case 'bordeGrey':
      case 'bordeGris':
        return 'No iniciada';
      default:
        return '';
    }

  }
  public actividadRojo(act: any){
    var valFin = 0, perfin = Meses.obtnerPer(new Date(act.end_date)), res = this.actividadesFull.filter(ac => ac.id === act.id);
    
    const ff = moment(Meses.escrituraPer(act.historico[0].periodo), 'MM/DD/YY');
    const fFin = moment(act.end_date);
    if(fFin.isBefore(ff)){
      if(res.length !== 0){
        var hist = res[0].historico;
        hist = this.ordenamientoId(hist);
        hist = this.ordenamientoPlaneado(hist);
        for(const h of hist){
          if(perfin !== h.periodo){
            if(h.ejecutado !== null){
              valFin = h.ejecutado;
            }
          }else{
            if(h.ejecutado !== null){
              valFin = h.ejecutado;
            }
            break;
          }
        }
      }
      let avan = this.avanceAcumuladoExport(res[0], act.historico[0].periodo)

      if(valFin === 0 && avan === 0){
        return 'colorRed';
      }
      return 'colorBlue'; 
    }
    return '';
  }
  // Menu click izquierdo
  public onContextMenu(event: MouseEvent, item, activiti) {
    event.preventDefault(); 
    // we record the mouse position in our object 
    this.menuTopLeftPosition.x = event.clientX + 'px'; 
    this.menuTopLeftPosition.y = event.clientY + 'px'; 

    this.adDelete = item;
    this.adActivi = activiti;

    this.matMenuTrigger.openMenu();
  }
  /** Ordenamiento */
  public ordenamientoTabla(){
    switch(this.ordenamiento){
      case 'id':
        this.proyectosMostrar = this.ordenamientoAlfAsc(this.proyectosMostrar);
        this.ordenamiento = 'asc';
      break;
      case 'asc':
        this.proyectosMostrar = this.ordenamientoAlfDes(this.proyectosMostrar);
        this.ordenamiento = 'des';
      break;
      case 'des':
        this.proyectosMostrar = this.ordenamientoIdSort(this.proyectosMostrar);
        this.ordenamiento = 'id';
      break;
    }
  }
  private ordenamientoNuevo(){
    switch(this.ordenamiento){
      case 'id':
        this.proyectosMostrar = this.ordenamientoIdSort(this.proyectosMostrar);
      break;
      case 'asc':
        this.proyectosMostrar = this.ordenamientoAlfAsc(this.proyectosMostrar);
      break;
      case 'des':
        this.proyectosMostrar = this.ordenamientoAlfDes(this.proyectosMostrar);
      break;
    }
  }
  /** Borrar filtros */
  public async borrarFiltro(){
    document.body.style.cursor = 'wait';

    this.perSelect = '';
    this.objSelect = '';
    this.proSelect = '';

    this.todasPer = true;
    this.responsables.forEach(res => res.check = true);
    this.todasPerAct = true;
    this.expandirProg = false;
    this.responsablesAct.forEach(res => res.check = true);
    var per = this.aniosDisponibles[this.aniosDisponibles.length-1].series[this.aniosDisponibles[this.aniosDisponibles.length-1].series.length-1]; 
    this.Periodo = per.periodo;
    this.mesMos = per.mes;
    this.aniMos = per.anio;
    for(const an of this.aniosDisponibles){
      for(const mes of an.series){
        if(mes.periodo !== this.Periodo){
          mes.check = false;
        }else{
          mes.check = true;
        }
      }
    }

    this.proyectosMostrar = [];
    try{
      this.obtenerProyectosPeriodo();
    }catch(err){
      messages.errorMessageGraph(err);
    }
    setTimeout(() => {
      document.body.style.cursor = 'default';
    }, 1000 );
  }
  /* Filtro de actividades del año del filtro */
  public cambioDeFiltrado(){
    this.mostrarPeriodo = !this.mostrarPeriodo;
    if(this.todasPer)
      this.obtenerProy('cam');
    else
      this.obtenerProy('all');
  }
  //Marcar todas
  public selecAllStatus(){
    this.allStats = !this.allStats;
    for(const s of this.estats){
      if(this.allStats){
        s.check = true;
      }else{
        s.check = false;
      }
    }
  }
  public seleccionar(st){
    st.check = !st.check;

    const sel = this.estats.reduce((acc, e) => e.check?acc+1:acc,0);

    if(sel === this.estats.length){
      this.allStats = true;
    }
  }
}